import { EntityVm } from 'api/core/entity.vm';
import { IsString } from 'class-validator';

export class WarehouseVm extends EntityVm {
  @IsString()
  name: string;

  @IsString()
  locationMask: string;
}
